import React, { ReactElement } from 'react';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import Link from 'next/link';
import classNames from 'classnames/bind';
import { PitchTitleIcon } from 'sections/Benefits/svg';
import styles from 'sections/Benefits/ShippingLeads/components/SectionPitch/SectionPitch.module.scss';

const cn = classNames.bind(styles);

const SectionPitch = (): ReactElement => {
  return (
    <section className={cn('pitch')}>
      <div className={cn('container')}>
        <div className={cn('pitch__title-box')}>
          <h2 className={cn('pitch__title')}>
            {PitchTitleIcon}
            Streamline Your Sales Pipeline with Exclusive Shipping Leads
          </h2>
          <p className={cn('pitch__title-description')}>
            Maximise your reach, minimise your effort - let the leads come to you.
          </p>
        </div>
        <div className={cn('pitch__paragraphs')}>
          <p className={cn('pitch__paragraph')}>
            Shipping leads are the lifeline of freight forwarders looking to expand their business.
            At DFA, we make connecting with potential customers seamless by providing real-time access
            to shipping requests from around the globe. Whether it’s a small parcel or a full container
            load, our platform ensures you’re first in line to offer competitive rates and secure
            bookings. By leveraging our extensive network and smart bidding tools, freight forwarders
            can increase their visibility, enhance sales, and build long-lasting client relationships.
            With DFA, your next big opportunity is just a lead away.
          </p>
        </div>
        {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
        {/* <div className={cn('pitch__buttons')}>
          <Link className={cn('pitch__button-join')} href="/membership">
            Join DFA Alliance Now
          </Link>
        </div> */}
      </div>
    </section>
  );
}

export default SectionPitch;